

const state = {

  show: false,

  title: '안내',
  content: '',
  submit: null,

  btn_close: false,

  show_btn: true,
  btn_cancel: false,
  btn_cancel_title: '취소',
  
  btn_submit: true,
  btn_submit_title :'확인',
}

const mutations = {
  SET_ALERT(state, payload){
    for (let key in payload) 
      if(typeof state[key] !== "undefined") 
        state[key] = payload[key];
  },

  CLEAR_ALERT(state) {
    state.show = false;
    state.title =  '안내';
    state.content = '';
    state.submit = null;
  
    state.btn_close = false;
  
    state.show_btn = true;
    state.btn_cancel = false;
    state.btn_cancel_title = '취소';
    
    state.btn_submit = true;
    state.btn_submit_title ='확인';
  }
}

export default {
  state,
  mutations,
}